/* NgRx */
import {createAction, props} from '@ngrx/store';
import {SideNavWeekList} from "../../../../models/side-nav-week-list";
import {ResourceList} from "../../../../models/resource-list";
import {FetchResourceListModel} from "../models/fetch-resource-list.model";
import {DailyDataModel} from "../../../../models/daily-data.model";
import {
  FetchSideNavWeeksListModel
} from "../models/fetch-side-nav-weeks-list.model";
import {WeekList} from "../../../../models/week-list";
import {FetchWeekSummaryModel} from "../models/fetch-week-summary.model";
import {UpdateDailyScoreModel} from "../models/update-daily-score.model";


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[behavior tracker] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH SIDE NAV WEEKS LIST ***********/
const FETCH_SIDE_NAV_WEEKS_LIST_REQUEST = '[behavior tracker] fetch side nav weeks list requested';
export const FetchSideNavWeeksListRequest = createAction(FETCH_SIDE_NAV_WEEKS_LIST_REQUEST, props<{
  payload: FetchSideNavWeeksListModel['request']
}>());

const FETCH_SIDE_NAV_WEEKS_LIST_SUCCESS = '[behavior tracker] fetch side nav weeks list successful';
export const FetchSideNavWeeksListSuccess = createAction(FETCH_SIDE_NAV_WEEKS_LIST_SUCCESS, props<{
  sideNavWeeksList: SideNavWeekList
  message: string
}>());

const FETCH_SIDE_NAV_WEEKS_LIST_FAILURE = '[behavior tracker] fetch side nav weeks list failure';
export const FetchSideNavWeeksListFailure = createAction(FETCH_SIDE_NAV_WEEKS_LIST_FAILURE);

/******** FETCH WEEKS LIST ***********/
const FETCH_WEEKS_LIST_REQUEST = '[behavior tracker] fetch weeks list requested';
export const FetchWeeksListRequest = createAction(FETCH_WEEKS_LIST_REQUEST, props<any>());

const FETCH_WEEKS_LIST_SUCCESS = '[behavior tracker] fetch weeks list successful';
export const FetchWeeksListSuccess = createAction(FETCH_WEEKS_LIST_SUCCESS, props<{
  weeksListInfo: WeekList,
  groupInfo: {},
  message: string
}>());

const FETCH_WEEKS_LIST_FAILURE = '[behavior tracker] fetch weeks list failure';
export const FetchWeeksListFailure = createAction(FETCH_WEEKS_LIST_FAILURE);

/******** FETCH RESOURCES LIST ***********/
const FETCH_RESOURCES_LIST_REQUEST = '[behavior tracker] fetch resources list requested';
export const FetchResourceListRequest = createAction(FETCH_RESOURCES_LIST_REQUEST, props<any>());

const FETCH_RESOURCES_LIST_SUCCESS = '[behavior tracker] fetch resources list successful';
export const FetchResourceListSuccess = createAction(FETCH_RESOURCES_LIST_SUCCESS, props<any>());

const FETCH_RESOURCES_LIST_FAILURE = '[behavior tracker] fetch resources list failure';
export const FetchResourceListFailure = createAction(FETCH_RESOURCES_LIST_FAILURE);

/******** FETCH WEEK SUMMARY ***********/
const FETCH_WEEK_SUMMARY_REQUEST = '[behavior tracker] fetch week summary requested';
export const FetchWeekSummaryRequest = createAction(FETCH_WEEK_SUMMARY_REQUEST, props<{
  payload: FetchWeekSummaryModel['request']
}>());

const FETCH_WEEK_SUMMARY_SUCCESS = '[behavior tracker] fetch week summary successful';
export const FetchWeekSummarySuccess = createAction(FETCH_WEEK_SUMMARY_SUCCESS, props<{
  weekSummary: DailyDataModel[]
  message: string
}>());

const FETCH_WEEK_SUMMARY_FAILURE = '[behavior tracker] fetch week summary failure';
export const FetchWeekSummaryFailure = createAction(FETCH_WEEK_SUMMARY_FAILURE);

/******** CLEAR SIDE NAV WEEKS LIST ***********/
const CLEAR_SIDE_NAV_WEEKS_LIST = '[behavior tracker] clear sidenav weeks list';
export const ClearSideNavWeeksList = createAction(CLEAR_SIDE_NAV_WEEKS_LIST);

/******** UPDATE DAILY SCORE ***********/
const UPDATE_DAILY_SCORE_REQUEST = '[behavior tracker] update daily score requested';
export const UpdateDailyScoreRequest = createAction(UPDATE_DAILY_SCORE_REQUEST, props<{
  payload: UpdateDailyScoreModel['request']
}>());

const UPDATE_DAILY_SCORE_SUCCESS = '[behavior tracker] update daily score successful';
export const UpdateDailyScoreSuccess = createAction(UPDATE_DAILY_SCORE_SUCCESS, props<{
  weekSummary: DailyDataModel[]
  message: string
}>());

const UPDATE_DAILY_SCORE_FAILURE = '[behavior tracker] update daily score failure';
export const UpdateDailyScoreFailure = createAction(UPDATE_DAILY_SCORE_FAILURE);
